import { Component, Input, OnInit, TemplateRef } from "@angular/core";
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ReplaySubject } from 'rxjs';

@Component({
    selector: 'app-template-placeholder',
    templateUrl: './template-placeholder.component.html',
    styleUrls: ['./template-placeholder.component.scss']
})
export class TemplatePlaceholderComponent {
    @Input() templateReplaySubject: ReplaySubject<TemplateRef<any> | null> | null = null;

    constructor() { }
}
